import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonTypes, LinkButton, StandardButton } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';

import { useTranslation } from '../../translations';
import UserMessageDeleteSoeknad from '../modal/userMessageDeleteSoeknad';

export enum ByttonType {
    SUBMIT = 'submit',
    BUTTON = 'button',
    RESET = 'reset',
}

interface Props {
    soeknadId: string | null | undefined;
    showSpinner: boolean;
    buttonType?: ByttonType;
    onNesteClick?: () => void;
    onForrigeClick?: () => void;
    buttonText?: string;
    startPage?: boolean;
}

const PageFooter: FC<Props> = ({
    soeknadId,
    showSpinner,
    buttonType = ByttonType.SUBMIT,
    onNesteClick,
    onForrigeClick,
    buttonText,
    startPage = false,
}) => {
    const navigate = useNavigate();
    const { button } = useTranslation();
    const [showModal, setShowModal] = useState<boolean>(false);

    const onClickAvbryt = () => {
        setShowModal(true);
    };

    const onClickNeste = () => {
        if (onNesteClick) {
            onNesteClick();
        }
    };

    const onClickForrige = () => {
        if (onForrigeClick) {
            onForrigeClick();
        } else {
            navigate(-1);
        }
    };

    return (
        <div className="margin-top-extra-large">
            <UserMessageDeleteSoeknad soeknadId={soeknadId} showModal={showModal} setShowModal={setShowModal} />
            <div className="row row-gap align-items">
                {startPage && (
                    <ButtonWithSpinner
                        type={buttonType}
                        data-track-id="kreditt-boliglaan-foerste-side-knapp"
                        data-track-linkname="neste"
                        onClick={onClickNeste}
                        buttonType={ButtonTypes.STANDARD_POSITIVE}
                        showSpinner={showSpinner}
                    >
                        {buttonText || button.neste}
                    </ButtonWithSpinner>
                )}
                {!startPage && (
                    <div className="column column-gap">
                        <StandardButton
                            data-track-id="kreditt-boliglaan-side-knapp"
                            data-track-linkname="forrige"
                            buttonType={ButtonTypes.STANDARD_NEGATIVE}
                            onClick={onClickForrige}
                        >
                            {button.forrige}
                        </StandardButton>
                        <ButtonWithSpinner
                            type={buttonType}
                            data-track-id="kreditt-boliglaan-side-knapp"
                            data-track-linkname="neste"
                            onClick={onClickNeste}
                            buttonType={ButtonTypes.STANDARD_POSITIVE}
                            showSpinner={showSpinner}
                        >
                            {buttonText || button.neste}
                        </ButtonWithSpinner>
                    </div>
                )}
                <LinkButton
                    data-track-id="kreditt-boliglaan-soeknad-avbryt"
                    data-track-linkname="avbryt"
                    onClick={onClickAvbryt}
                >
                    {button.avbryt}
                </LinkButton>
            </div>
        </div>
    );
};

export default PageFooter;
